/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {FormControl} from 'baseui/form-control'
import {Input} from 'baseui/input'
import {StyledLink} from 'baseui/link'
import {ParagraphSmall} from 'baseui/typography'
import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {assets, routes} from '../../utils/config'
import {loginWithCredentials} from '../persistence/auth-actions'

const Login = () => {
  const dispatch = useDispatch()
  const {loading} = useSelector(state => state.app)
  const [credentials, setCredentials] = useState({email: '', password: ''})

  const isDisabled = () => {
    // noinspection JSDeepBugsBinOperand
    return loading || !credentials.email.trim() || !credentials.password.trim()
  }

  const handleChangeCredentials = event => {
    const {target} = event
    setCredentials(state => ({...state, [target.name]: target.value}))
  }

  const handleLogin = async event => {
    event.preventDefault()
    dispatch(loginWithCredentials(credentials))
  }

  return (
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            marginTop: $theme.sizing.scale800,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: $theme.sizing.scale800,
            paddingRight: $theme.sizing.scale800,
            width: 100 + '%',
            maxWidth: 20 + 'rem',
            position: 'relative',
            overflow: 'hidden',
            zIndex: 1,
            [$theme.media.small]: {
              marginTop: $theme.sizing.scale2400,
              overflow: 'hidden',
              maxWidth: '20rem',
            },
            [$theme.media.medium]: {
              marginTop: $theme.sizing.scale2400,
              overflow: 'hidden',
              maxWidth: '20rem',
            },
          }),
        },
      }}
    >
      <Block $as="header">
        <Block
          $as="img"
          src={assets.logo.verticalPurple}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                width: '100%',
                [$theme.media.small]: {
                  height: '10rem',
                },
                [$theme.media.medium]: {
                  height: '12rem',
                },
              }),
            },
          }}
        />
      </Block>
      <Block
        overrides={{
          Block: {
            style: ({$theme}) => ({
              backgroundColor: 'rgba(255,250,240,0.35)',
              borderRadius: $theme.sizing.scale400,
              paddingLeft: $theme.sizing.scale400,
              paddingRight: $theme.sizing.scale400,
              paddingTop: $theme.sizing.scale0,
              paddingBottom: $theme.sizing.scale0,
              marginTop: $theme.sizing.scale1200,
            }),
          },
        }}
      >
        <Block
          $as="form"
          onSubmit={handleLogin}
          noValidate
          overrides={{
            Block: {
              style: {
                display: 'flex',
                flexDirection: 'column',
              },
            },
          }}
        >
          <FormControl label="Email">
            <Input
              type="email"
              name="email"
              autoComplete="off"
              value={credentials.email}
              onChange={handleChangeCredentials}
            />
          </FormControl>
          <FormControl
            label="Password"
            overrides={{
              Label: {
                style: ({$theme}) => ({
                  marginTop: 0,
                }),
              },
            }}
          >
            <Input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChangeCredentials}
            />
          </FormControl>
          <Button
            isLoading={loading}
            disabled={isDisabled()}
            type="submit"
            overrides={{
              BaseButton: {
                style: ({$theme}) => ({
                  // marginTop: $theme.sizing.scale800,
                }),
              },
            }}
          >
            Log in
          </Button>
        </Block>
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({}),
            },
          }}
        >
          <ParagraphSmall>
            Forgot password?{' '}
            <StyledLink $as={Link} to={routes.passwordReset.url}>
              Reset it
            </StyledLink>
          </ParagraphSmall>
          <ParagraphSmall>
            Not Registered?{' '}
            <StyledLink $as={Link} to={routes.signUp.url}>
              Click here to sign up!
            </StyledLink>
          </ParagraphSmall>
        </Block>
      </Block>
    </Block>
  )
}

export default Login
